import AxiosInstance from '../../helpers/axios-instance/axios-instance';
import { appConfig } from '../../helpers/app-config/app-config';
import type { SubprojectStatusesResponse } from './subprojects-client.type';

const axiosInstance = AxiosInstance();
const baseURL = appConfig.VITE_APP_API_URL;

/**
 * Fetches a board's workflow status names in their original external-system
 * casing, for use as display labels.
 *
 * Returns an empty array rather than throwing when the response body is
 * missing or malformed, so a board with no statuses configured (a valid `200`
 * with `{ "statuses": [] }`) and a nonsense payload both degrade to "no
 * labels" instead of breaking the label lookup. Genuine transport failures
 * (including the `404` used for both missing and forbidden boards) still
 * reject so React Query can record the error.
 *
 * @param {string} subprojectId - The board/subproject UUID to fetch statuses for
 * @returns {Promise<string[]>} Status names in source casing, or `[]` when the payload carries none
 */
const getSubprojectStatuses = (subprojectId: string): Promise<string[]> => {
  const url = `${baseURL}/api/subprojects/${subprojectId}/statuses/`;
  return axiosInstance.get<SubprojectStatusesResponse>(url).then((response) => {
    const statuses = response?.data?.statuses;
    return Array.isArray(statuses) ? statuses.filter((status) => typeof status === 'string') : [];
  });
};

export { getSubprojectStatuses };
